import React from 'react';
import Section from '../components/Section';

import styles from './Quotation.module.scss';

const Quote = ({ author, description, quote, small }) => {
  return (
    <div
      className={`${styles.quote} ${
        small ? styles.smallQuote : styles.largeQuote
      }`}
    >
      <div className={styles.quoteQuote}>{quote}</div>
      <div className={styles.quoteInfos}>
        <div className={styles.quoteInfosDescription}>{description}</div>
        <div className={styles.quoteInfosAuthor}>{author}</div>
      </div>
    </div>
  );
};

export default ({ quotes }) => {
  if (quotes)
    return (
      <Section light>
        <div className={styles.symbolWrapper}>
          <span className={styles.symbol}>“</span>
        </div>
        <div className={styles.wrapper}>
          {quotes.map((x, index) => (
            <Quote {...x} key={index} small={index % 3 !== 0} />
          ))}
        </div>
      </Section>
    );
  return <></>;
};
